import { injectable, inject } from 'inversify';
import { SuspendDataStore, SuspendDataStoreSymbol, SuspendDataStateStore } from '@/app/tracking/common';
import { ExamTrackingState, defaultExamTrackingState } from './exam-tracking-state'
import { ExamCommand, examStateReducer } from './exam-state-reducer';

interface ExamsSuspendData {
  exams: ExamTrackingState[];
}

@injectable()
export class ExamSuspendDataStore {

  private store: SuspendDataStateStore<ExamTrackingState, unknown, ExamCommand>;

  constructor(
    @inject(SuspendDataStoreSymbol)
    suspendDataStore: SuspendDataStore<ExamsSuspendData>) {

    this.store = new SuspendDataStateStore(
      () => suspendDataStore.get2('exams'),
      (data: ExamTrackingState[]) => suspendDataStore.update2('exams', data),
      (id) => defaultExamTrackingState(id),
      examStateReducer);
  }

  public async query(ids: string[] | 'all') {
    return this.store.query(ids);
  }

  public async execute(command: ExamCommand) {
    await this.store.execute(command);
  }
}
